<template>
  <main id="trips" class="animated fadeIn">
    <h1>{{ this.$t("qrAccess.travels.title") }}</h1>
    <div class="switchs">
      <SwitchButtons name="trips" :values="types" @tipo="setTable" />
      <!-- <initTravelsTable /> -->
      <initTravelsTable v-if="tableToShow === 'initTravels'"></initTravelsTable>
      <ongoingTravels v-if="tableToShow === 'ongoingTravels'"></ongoingTravels>
      <endTravels v-if="tableToShow === 'endTravels'"></endTravels>
    </div>
  </main>
</template>

<script>
  const SwitchButtons = () => import("@/components/Switch");
  import initTravelsTable from "../Trips/tables/InitTravels";
  import ongoingTravels from "../Trips/tables/OngoingTravels";
  import endTravels from "../Trips/tables/EndTravels";
  export default {
    props: {
      travelStatus: {
        type: String
      }
    },
    components: {
      SwitchButtons,
      initTravelsTable,
      ongoingTravels,
      endTravels
    },
    data() {
      return {
        tableToShow: "",
        types: [
          {
            label: this.$t("qrAccess.travels.tabs.initTravels"),
            value: "initTravels",
            selected: false
          },
          {
            label: this.$t("qrAccess.travels.tabs.ongoingTravels"),
            value: "ongoingTravels",
            selected: false
          },
          {
            label: this.$t("qrAccess.travels.tabs.endTravels"),
            value: "endTravels",
            selected: false
          }
        ]
      };
    },
    async beforeMount() {
      switch (this.travelStatus){
        case 'travelToStart':
          this.tableToShow = "initTravels";
          this.types[0].selected = true;
        break;
        case 'travelInProgress':
          this.tableToShow = "ongoingTravels";
          this.types[1].selected = true;
        break;
        case 'travelFinished':
          this.tableToShow = "endTravels"
          this.types[2].selected = true;
        break;
        default:
          this.tableToShow = "initTravels"
          this.types[0].selected = true;
        break;
      }
    },
    methods: {
      setTable: function(types) {
        this.tableToShow = types;
      }
    },
    // computed: {
    //   types: function() {
    //     return this.types;
    //   }
    // }
  };
</script>

<style lang="scss" scoped></style>
